import React from "react";
import Skeleton from "react-loading-skeleton";
import { tokens } from "../public/tokens";

const { globals } = tokens;

const SkeletonLoaderBasic = () => {
    return (
        <div style={{ flex: 1 }}>
            <Skeleton height={252} style={{ borderRadius: globals["border-radius"] }} />
        </div>
    );
};

export default SkeletonLoaderBasic;
